import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';

export const BgContentWrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

export const accordionLabelStyle = (theme: Theme) => css`
  color: ${theme.color.blue.default};
  background: ${theme.color.blue.glassShade};
`;

export const Row = styled.div`
  display: flex;
  gap: 16px;

  > * {
    width: 50%;
  }
`;

export const Item = styled.div`
  margin-bottom: 12px;
`;

export const Image = styled.img`
  border-radius: 8px;
  width: calc(50% - 4px);
  max-width: 400px;
  margin: 0 auto;
`;

export const SubscribeButtonWrapper = styled.div`
  margin-top: 12px;
  width: 50%;
  text-align: center;
`;

export const Content = styled.div`
  padding: 15px 25px;
`;
export const VetAdviceWrapper = styled.div`
  padding-top: 18px;
`;

export const Category = styled.div`
  margin-bottom: 18px;
`;

export const CategoryTitle = styled.div`
  font-weight: 600;
`;

export const BgImage = styled.img`
  position: absolute;
  left: 0;
  right: 0;
  top: 100px;
  width: 100%;

  ${mediaQuery(BREAKPOINTS.medium)} {
    display: none;
  }
`;

export const HelperBox = styled.div`
  color: ${(props) => props.theme.color.purple.default};
  background-color: ${(props) => props.theme.color.purple.tint};
  padding: 16px;
  border-radius: 8px;
  margin-top: 14px;
  font-size: 14px;
  text-align: center;

  svg {
    vertical-align: middle;
    margin-right: 4px;
  }
`;
